import React, { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { ShieldAlert, X } from 'lucide-react';

function fmtRemaining(ms) {
  if (ms <= 0) return '0:00';
  const total = Math.floor(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/**
 * Globales Banner, das während eines Support-Logins (Impersonation) oben
 * sichtbar bleibt. Zeigt als wen man angemeldet ist, einen Countdown bis
 * zum automatischen Ablauf und einen Button zum sofortigen Verlassen.
 */
export default function SupportModeBanner() {
  const { impersonating, stopImpersonation } = useAuth();
  const [now, setNow] = useState(Date.now());
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!impersonating) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [impersonating]);

  if (!impersonating) return null;

  const remaining = (impersonating.exp || 0) - now;
  const label = impersonating.name || impersonating.email;

  const leave = async () => {
    setLeaving(true);
    try { await stopImpersonation(); } finally { setLeaving(false); }
  };

  return (
    <div
      data-testid="support-mode-banner"
      className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-black shadow-lg"
    >
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span className="truncate">
        Support-Modus aktiv — angemeldet als <strong>{label}</strong> ({impersonating.email})
      </span>
      <span className="shrink-0 rounded bg-black/15 px-2 py-0.5 font-mono text-xs" data-testid="support-mode-countdown">
        {fmtRemaining(remaining)}
      </span>
      <button
        onClick={leave}
        disabled={leaving}
        data-testid="support-mode-exit"
        className="inline-flex shrink-0 items-center gap-1 rounded-md bg-black/80 px-3 py-1 text-xs font-semibold text-white hover:bg-black disabled:opacity-60"
      >
        <X className="h-3.5 w-3.5" />
        Support-Modus verlassen
      </button>
    </div>
  );
}
